import { computed } from 'vue';
import { BORDERS, COLORS } from '@model/slices/basic-slice.js';

export const styleProps = {
    margin: { type: String, default: undefined, required: false },
    padding: { type: String, default: undefined, required: false },
    noBottomPadding: { type: Boolean, default: false },
    borderTop: { type: String, validator: (v) => !v || BORDERS.includes(v) },
    borderBottom: { type: String, validator: (v) => !v || BORDERS.includes(v) },
    background: {
        type: String,
        validator: (v) => v === undefined || COLORS.includes(v),
        default: 'white',
    },
};

export function useStyle(props: any) {
    const className = computed(() => ({
        's-slice_no-bottom-padding': props.noBottomPadding,
        's-slice_border-bottom': props.borderBottom,
        [`s-slice_border-bottom_${props.borderBottom}`]: props.borderBottom,
        's-slice_border-top': props.borderTop,
        [`s-slice_border-top_${props.borderTop}`]: props.borderTop,
        [`s-slice_background_${props.background}`]: props.background,
        ...(props.padding ? { [props.padding]: true } : {}),
        ...(props.margin ? { [props.margin]: true } : {}),
    }));
    return { className };
}
